import { render, staticRenderFns } from "./ota-upload-list.vue?vue&type=template&id=16939d92&scoped=true&"
import script from "./ota-upload-list.vue?vue&type=script&lang=ts&"
export * from "./ota-upload-list.vue?vue&type=script&lang=ts&"
import style0 from "./ota-upload-list.vue?vue&type=style&index=0&id=16939d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16939d92",
  null
  
)

export default component.exports